import { MenuItem } from "../../Types/Layout/SidebarType";
import {
  account,
  admin,
  AttendanceRequests,
  conveyancePath,
  ConveyanceTitle,
  Dashboard,
  dashboardPath,
  downloadsPath,
  EmployeeZone,
  expenseManagerPath,
  ExpenseZone,
  home,
  hr,
  ReimbursementFormModal,
  imbursementPath,
  inventoryManager,
  lanClass1,
  lanClass3,
  lanClass4,
  leavePath,
  LeaveRequests,
  link,
  manager,
  managerMembersAttendancePath,
  managerMembersLeavePath,
  managerPath,
  ManagerZone,
  maps,
  MarkAttendance,
  officeBoy,
  sub,
  TeamMembers,
  user,
  ViewAttendance,
  viewAttendancePath,
  ViewLeaves,
  vip,
  expenseAccountZonePath,
  AccountZone,
  AdminZone,
  surveyFormPath,
  SurveyForm,
  Department,
  departmentPath,
  Designation,
  trainingPath,
  policesPath,
  Inventory,
  Centers,
} from "../../utils/Constant";

export const menuList: MenuItem[] = [
  {
    // title: "",
    lanClass: lanClass1,
    Items: [
      {
        title: Dashboard,
        id: 1,
        icon: home,
        path: dashboardPath,
        type: link,
        lanClass: lanClass3,
        roles: [
          hr,
          manager,
          admin,
          user,
          vip,
          officeBoy,
          account,
          inventoryManager,
        ],
      },
      // {
      //   path: "/search/users",
      //   title: "Search Bar",
      //   id: 2,
      //   icon: "search",
      //   type: link,
      //   lanClass: lanClass3,
      // },
      // {
      //   title: "User Management",
      //   id: 3,
      //   icon: "home",
      //   type: "sub",
      //   lanClass: lanClass3,
      //   children: [
      //     {
      //       path: "usermanagement/users",
      //       title: "Users",
      //       type: link,
      //       lanClass:lanClass4,
      //     },
      //   ],
      // },
      {
        title: MarkAttendance,
        icon: maps,
        path: "/employee-zone/attendance-status",
        type: link,
        lanClass: lanClass3,
        roles: [
          hr,
          manager,
          admin,
          user,
          vip,
          officeBoy,
          account,
          inventoryManager,
        ],
      },
      {
        title: EmployeeZone,
        id: 4,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [
          hr,
          manager,
          admin,
          user,
          vip,
          // officeBoy,
          account,
          inventoryManager,
        ],
        children: [
          // {
          //   path: "/employee-zone/daily-report",
          //   title: DailyReport,
          //   type: link,
          //   lanClass:lanClass4,
          // },
          {
            path: viewAttendancePath,
            title: ViewAttendance,
            type: link,
            lanClass: lanClass4,
          },

          {
            path: leavePath,
            title: ViewLeaves,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: conveyancePath,
            title: ConveyanceTitle,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: `${expenseManagerPath}`,
            title: "Petty Cash",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/employee-zone/daily-dairy",
            title: "Work Diary",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: imbursementPath,
            title: ReimbursementFormModal,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/user/surveys",
            title: "Forms",
            type: link,
            lanClass: lanClass4,
          },
          // {
          //   path: "/my-assets",
          //   title: "My Assets",
          //   type: link,
          //   lanClass: lanClass4,
          // },
        ],
      },
      {
        title: ManagerZone,
        id: 5,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [manager, hr, "Admin", "admin"],
        children: [
          {
            path: managerPath,
            title: TeamMembers,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: managerMembersLeavePath,
            title: LeaveRequests,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: managerMembersAttendancePath,
            title: AttendanceRequests,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/members/conveyance",
            title: "Conveyance",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/members/daily-dairy-report",
            title: "Daily Dairy Report",
            type: link,
            lanClass: lanClass4,
          },
        ],
      },
      {
        title: AdminZone,
        id: 6,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: ["Admin", "admin"],
        children: [
          // {
          //   path: "/calling-system/user-register",
          //   title: "Calling System List",
          //   type: link,
          //   lanClass: lanClass4,
          // },
          {
            path: "/daily-task-list",
            title: "Daily Task List",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: surveyFormPath,
            title: SurveyForm,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: departmentPath,
            title: Department,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/designation/index",
            title: Designation,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/centerList",
            title: Centers,
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/attendance-policy",
            title: "Attendance Scheme",
            type: link,
            lanClass: lanClass4,
          },
        ],
      },
      // {
      //   title: Downloads,
      //   icon: file,
      //   path: downloadsPath,
      //   type: link,
      //   lanClass: lanClass3,
      //   roles: [
      //     hr,
      //     manager,
      //     admin,
      //     user,
      //     vip,
      //     // officeBoy,
      //     account,
      //     inventoryManager,
      //   ],
      // },
      // {
      //   title: ReimbursementFormModal,
      //   icon: file,
      //   path: imbursementPath,
      //   type: link,
      //   lanClass: lanClass3,
      //   roles: [
      //     hr,
      //     manager,
      //     admin,
      //     user,
      //     vip,
      //     officeBoy,
      //     account,
      //     inventoryManager,
      //   ],
      // },
      {
        title: "HR ZONE",
        id: 7,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [hr, "Admin", "admin"],
        children: [
          // {
          //   path: "/hr-zone/users",
          //   title: "Users",
          //   type: link,
          //   lanClass: lanClass4,
          // },
          // {
          //   path: "/calling-system/user-register",
          //   title: "Calling System",
          //   type: link,
          //   lanClass: lanClass4,
          // },
          {
            path: "/hr-zone/employee-attendance",
            title: "Attendance Requests",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/hr-zone/employee-leaves",
            title: "Leaves Requests",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/hr-zone/comp-off",
            title: "Comp-Off Management",
            type: link,
            lanClass: lanClass4,
          },
          // {
          //   path: "/hr-zone/employee-manager",
          //   title: "Employee's Manager",
          //   type: link,
          //   lanClass: lanClass4,
          // },
          {
            path: "/hr-zone/employee-probation",
            title: "Probation",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/hr-zone/users",
            title: "Users",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/hr-zone/employee-conveyance",
            title: "Conveyance",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/hr-zone/employee-conveyance-approved",
            title: "Approved Conveyance",
            type: link,
            lanClass: lanClass4,
          }
        ],
      },
      {
        title: Inventory,
        id: 8,
        icon: user,
        path: "inventory-products",
        type: link,
        lanClass: lanClass3,
        roles: ["Admin", "admin"],
      },
      // {
      //   path: "/download",
      //   title: "Download(s)",
      //   id: 6,
      //   icon: "home",
      //   type: link,
      //   lanClass: lanClass3,
      //   roles: [manager, hr,admin],
      // },
      {
        title: AccountZone,
        id: 9,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [admin, hr, account],
        children: [
          {
            path: expenseAccountZonePath,
            title: "Expense Account",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/account-zone/conveyance",
            title: "Conveyance",
            type: link,
            lanClass: lanClass4,
          },
        ],
      },
      {
        title: "Reports",
        id: 10,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [admin, hr],
        children: [
          {
            path: "/reports/employee-attendance-report",
            title: "Attendance Report",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/reports/employee-salary-report",
            title: "Attendance Summary",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/reports/conveyance-report",
            title: "Conveyance Report",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/reports/employee-report",
            title: "Employee Report",
            type: link,
            lanClass: lanClass4,
          },

          {
            path: "/reports/employee-leave-report",
            title: "Leave Report",
            type: link,
            lanClass: lanClass4,
          },

          {
            path: "/reports/employee-month-wise-report",
            title: "Monthly Report",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: "/reports/reimbursement-report",
            title: "Reimbursement Report",
            type: link,
            lanClass: lanClass4,
          },
        ],
      },
      {
        title: "Organization",
        id: 11,
        icon: user,
        type: sub,
        lanClass: lanClass3,
        roles: [
          hr,
          manager,
          admin,
          user,
          vip,
          // officeBoy,
          account,
          inventoryManager,
        ],
        children: [
          {
            path: policesPath,
            title: "Company Policy",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: downloadsPath,
            title: "Content",
            type: link,
            lanClass: lanClass4,
          },
          {
            path: trainingPath,
            title: "Training Resources",
            type: link,
            lanClass: lanClass4,
          },
        ],
      },
      {
        id: 12,
        title: "Calling System List",
        icon: "call",
        path: "/calling-system/user-register",
        type: link,
        lanClass: lanClass3,
        roles: ["Admin", "admin"],
      },
    ],
  },
];
